export default "__VITE_ASSET__DVwZ$wUX__"